import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export const Logo = ({ light = false, to = "/" }) => (
  <Link to={to} data-testid="navbar-brand-logo" className="group inline-flex items-center gap-2.5">
    <span className={`flex h-9 w-9 items-center justify-center rounded-xl ${light ? "bg-white/10 text-white" : "bg-[#1e3a8a] text-white"}`}
      style={{ transition: "transform 200ms ease" }}>
      <ShieldCheck className="h-5 w-5 group-hover:scale-110" style={{ transition: "transform 200ms ease" }} />
    </span>
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#1e3a8a]"}`}>
      Affitto<span className={light ? "text-[#93c5fd]" : "text-[#2563eb]"}>Sicuro</span>
    </span>
  </Link>
);
